import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step } from '@/composables/tour/stepHelpers';

registerTourPage('admin-home', {
  key: 'admin-home',
  label: 'Admin Home',
  getSteps: () => [
    step({
      target: '#tour-home-pulse',
      title: 'Your Pulse',
      content:
        'Today\'s key numbers — students, attendance, fees collected, and other quick metrics. Each card links to its full module.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-home-main-column',
      title: 'Today at a Glance',
      content:
        'Your upcoming classes, assignments to grade, scores still to record, and active tests live here. Click any card to jump straight in.',
      placement: 'right',
    }),
    step({
      target: '#tour-home-side-column',
      title: 'Roles, Activity & Attendance',
      content:
        'Your assigned roles, recent activity log, today\'s attendance summary, and the attendance trend chart for the term.',
      placement: 'left',
    }),
    step({
      target: '#tour-home-quick-actions',
      title: 'Quick Actions',
      content:
        'Shortcuts for the things you do most — register a student, mark attendance, create a bill, or upload results. Only the actions you have permission for will appear here.',
      placement: 'top',
    }),
    step({
      target: '#app-tour-trigger',
      title: 'Replay Anytime',
      content:
        'Click this button on any page to take a guided tour of that screen. New pages will pulse to let you know a tour is available.',
      placement: 'bottom',
    }),
  ],
});
